module.exports = __webpack_public_path__ + "img/21_77.6a6928e9.png";